var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"px-2 inline-flex text-xs leading-5 font-semibold rounded-full items-center",class:_vm.statusClass},[_vm._v(" "+_vm._s(_vm.$t(_vm.status))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }